import { render, staticRenderFns } from "./About.vue?vue&type=template&id=e8377858&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"
import style0 from "./About.vue?vue&type=style&index=0&id=e8377858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8377858",
  null
  
)

export default component.exports